/**
 * Google Maps API utility functions
 * Runtime helpers for working with Google Maps API
 */

import type {
  GoogleAPI,
  GoogleMapsAPI,
  GoogleMapsAutocompleteService,
  GoogleMapsPlacesAPI,
  GoogleMapsWindow,
} from 'types/google-maps';

/**
 * Type guard to check if Google Maps API is available
 */
export function isGoogleMapsAvailable(window: Window): window is GoogleMapsWindow & {
  google: GoogleAPI & {
    maps: GoogleMapsAPI & {
      places: GoogleMapsPlacesAPI;
    };
  };
} {
  return !!(window as GoogleMapsWindow).google?.maps?.places?.AutocompleteService;
}

/**
 * Utility function to safely access Google Maps API
 */
export function getGoogleMapsAPI(window: Window): GoogleAPI | null {
  if (isGoogleMapsAvailable(window)) {
    return window.google;
  }
  return null;
}

/**
 * Utility function to safely create AutocompleteService
 */
export function createAutocompleteService(window: Window): GoogleMapsAutocompleteService | null {
  if (isGoogleMapsAvailable(window)) {
    return new window.google.maps.places.AutocompleteService();
  }
  return null;
}